module.exports = __webpack_public_path__ + "img/q-1-1@2x.01690d92.png";